import { Close } from "@mui/icons-material"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Typography } from "@mui/material"
import { de } from "date-fns/locale"
import { useState } from "react"

export const DialogFile = ({ file, open, onClose, onOpenFile, onDelete, intl }) => {

    const [deleteConfirmation, setDeleteConfirmation] = useState(false)

    const handleClose = () => {
        setDeleteConfirmation(false)
        onClose()
    }

    return (
        <div>
            <Dialog open={open} onClose={onClose}
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                        },
                    },
                }}
            >
                <DialogTitle
                    sx={{
                        m: 0,
                        p: 2,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        textOverflow: "ellipsis",
                    }}
                    id="alert-dialog-title">
                    {file.filename}
                    <IconButton
                        aria-label="close"
                        color="primary"
                        onClick={handleClose}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                {
                    deleteConfirmation ?
                        (
                            <>
                                <DialogContent>
                                    <Typography color="text.secondary" component='h1' variant='h5' mt={2}>
                                        {intl.formatMessage({ id: "confirm.delete.file" })}
                                    </Typography>
                                </DialogContent>
                                <DialogActions >
                                    <Stack direction="row" spacing={2}>
                                        <Button
                                            variant="outlined"
                                            onClick={() => setDeleteConfirmation(false)}
                                        >
                                            {intl.formatMessage({ id: "cancel" })}
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="error"
                                            onClick={() => {
                                                onDelete(file)
                                                handleClose()
                                            }}
                                        >
                                            {intl.formatMessage({ id: "delete" })}
                                        </Button>
                                    </Stack>
                                </DialogActions>
                            </>
                        )
                        :
                        (
                            <>
                                <DialogContent>
                                    <Typography color="text.secondary" component='h1' variant='h5' mt={2}>
                                        {intl.formatMessage({ id: "select.action" })}
                                    </Typography>
                                </DialogContent>
                                <DialogActions >
                                    <Stack direction="row" spacing={2}>
                                        <Button
                                            variant="outlined"
                                            onClick={() => {
                                                onOpenFile(file)
                                                handleClose()
                                            }}
                                        >
                                            {intl.formatMessage({ id: "open.file" })}
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="error"
                                            onClick={() => setDeleteConfirmation(true)}
                                        >
                                            {intl.formatMessage({ id: "delete" })}
                                        </Button>
                                    </Stack>
                                </DialogActions>
                            </>
                        )
                }
            </Dialog>
        </div>
    )
}